<template>
  <div  class="buying-tickets-list">
      <!-- header -->
      <div class="header">
          <img src="@a/be-myself/2020/city-max.png" alt="">
          <div class="text">{{address?address+' 会场':'全部会场'}}</div>
          <div @click="selectCityShow=true" class="selct-hall">选会场</div>
      </div>
      <!-- list -->
      <div class="box">
        <van-list :error.sync="error" error-text="请求失败，点击重新加载" :offset="200" v-model="loading" :finished="finished" finished-text="没有更多了" @load="pullData()">
            <div @click="toDetails(item.id)" v-for="(item,index) in list" :key="index" class="list"  v-show="item.id!=330 && item.id!=331 && item.id!=332">
              <img class="left" :src="item.thumb?item.thumb:'https://misc.xjy.cn/zuoziji/fm.jpg'" alt="">
              <div class="text">
                  <div class="h3 text-ellipsis-2">
                    {{item.name}}
                  </div>
                  <div class="city">
                    <img src="@a/be-myself/2020/city-min.png" alt="">
<!--                    <span>{{getCity(item.province)?item.province:(item.province +'  '+ item.city +'  '+ item.district)}} 会场</span>-->
                    <span>{{item.province +'  '+ item.city+'  '+ item.district}} 会场</span>
                  </div>
<!--                  <div class="time">-->
<!--                    <img src="@a/be-myself/2020/time.png" alt="">-->
<!--                    <span class="t">12月30日·{{JSON.parse(item.detail)?JSON.parse(item.detail).createTime:''}}</span>-->
<!--                  </div>-->
                  <div class="money-box">
                        <template v-if="item.stock<=0">
                            <span class="text-mon on">已售罄</span>
                        </template>
                        <template v-else>
                            <span v-if="item.original_price" class="money" style="text-decoration: line-through;font-weight: normal;color: #999;font-size: 0.36rem;">原价￥{{item.original_price/100}}</span>
                            <span class="money">￥{{item.price/100}}</span>
                            <span class="text-mon">剩余 <sapn style="color:#0890CE;">{{item.stock-item.sold}}</sapn> 张票</span>
                        </template>
                    </div>
              </div>
          </div>
        </van-list>
      </div>
      <!--  -->
        <van-popup v-model="selectCityShow" position="bottom"  @close="pickerShowClick(false)" >
            <!-- <van-area  :area-list="areaList" :columns-num="3"  @cancel="selectCityShow=false" @confirm="cityCfm" /> -->
            <van-picker  show-toolbar  :columns="columns"  @confirm="cityCfm"  @cancel="selectCityShow=false" />
        </van-popup>
  </div>
</template>

<script>
import areaList from "@/utils/area";
import { productList,productAll } from "@/api/be_myself"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            loading: false,
            finished: false,
            error: false,
            address:'',
            area:[],
            list:[],
            pages:{
                page: 0,
                size: 10,
            },
            // 选择省市区
            selectCityShow:false,
            areaList, //省市数组
            columns:[]
        }
    },
    methods:{
        getCity(val){
            return (val==='北京市' || val==='天津市'  || val==='重庆市' || val==='上海市' || val==='台湾省')
        },
        // 跳转到详情
        toDetails(id){
            this.$router.push({
                path:'/buying_tickets_details',
                query:{
                    id
                }
            });
        },
        // 确认选择城市触发
        cityCfm(picker) {
            // this.area = [picker[0].name,picker[1].name,picker[2].name];
            // this.address = picker[0].name + ' ' + picker[1].name;
            let pickerArr = picker.split('/');
            if(pickerArr && pickerArr.length>0){
                if(this.getCity(pickerArr[0])){
                    this.area = [pickerArr[0]];
                    this.address = pickerArr[0] + ' ';
                }else{
                    this.area = [pickerArr[0],pickerArr[1]];
                    this.address = pickerArr[0] + ' ' + pickerArr[1];
                }
               
                this.cfmTreeSelect();
                this.selectCityShow = false;   
            }
        },
        /*
       *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-28 12:18:35
      */
      pickerShowClick(newval) {
        let self = this;
        if (newval) {
          document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //阻止默认事件
        } else {

          document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //打开默认事件
        }
      },
        b64Decode(str) {
            
            return decodeURIComponent(window.atob(str));
        },
        // 确认筛选
        cfmTreeSelect(){
            this.pages.page=0;
            this.pages.size=25;
            this.list = [];
            this.pullData();
        },
        // 获取初始数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"超级个体，更值钱更热爱更自在(σ≧∀≦σ)");
            this.pages.page += 1;
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:1,//做自己节传1
                status:1
            };
            if(this.area.length>0){
                obj['province'] = this.area[0];
                if(this.area[1]){
                    obj['city'] = this.area[1];
                }
                // obj['district'] = this.area[2];
            }else{
                if(q.city){
                    let arr = this.b64Decode(q.city).split('/')?this.b64Decode(q.city).split('/'):['','',''];
                    this.address = arr[0]+' '+ (arr[1]?arr[1]:'');
                    obj['province'] = arr[0];
                    if(arr[1]){
                        obj['city'] = arr[1];
                    }
                    if(arr[2]){
                        obj['district'] = arr[2];
                    }
                }
            }
            productList(obj).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.pages = data.pager;
                this.list = Array.from(new Set([...this.list,...data.list]));
                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if(data.pager.page_count == data.pager.page) {
                    this.finished = true;
                }
            }).catch(err=>{
                this.error = true;
            });
            // 判断是否是存在数据
            if(this.columns.length<=0){
                // 获取所有商品
                productAll({
                    category_id:1,  //1做自己节  2选对
                    status:1  // 1上架  2下架
                    }).then((data)=>{
                    if(data.error>0){
                        this.$toast(data.detail);
                        return
                    }
                    let arr = data.list.sort((a,b)=>{
                        return a.province>b.province?1:-1
                    })
                    let temp = arr.map(v=>{
                        return v.province + '/' + v.city
                    });
                    this.columns = Array.from(new Set(temp));
                    shareCon("beMyself", this);
                    // this.columns = data.list.map(v=>{
                    //     return v.province + '/' + v.city
                    // });
                })
            }
        }
    },
    created(){
        // this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #FFFFFF;
    }
</style>
<style lang="scss" scoped>
.buying-tickets-list{
    .header{
        display: flex;
        align-items: center;
        padding: 22px 24px;
        margin-bottom: 8px;
        background-color: #FFFFFF;
        img{
            width: 46px;
            margin-right: 18px;
        }
        .text{
            font-size:28px;
            color:#333333 ;
            margin-right: auto;
        }
        .selct-hall{
            width: 144px;
            height: 56px;
            line-height: 56px;
            background: #FFFFFF;
            border-radius: 28px;
            border: 2px solid #0890CE;
            text-align: center;
            font-size: 28px;
            color: #0890CE;
        }
    }
    .box{
        background-color: #FFFFFF;
        padding: 30px 24px;
        .list{
            padding: 24px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.23);
            border-radius: 8px;
            display: flex;
            margin-bottom: 24px;
            &:last-child{
                margin-bottom: 0px;
            }
            .left{
                width: 178px;
                height: 212px;
                margin-right: 10px;
            }
            .text{
                flex: 1;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .h3{
                    font-size: 32px;
                    color: #333333;
                    line-height: 48px;
                    font-weight: bold;
                    margin-bottom: 15px;
                    width: 465px;
                }
                .city{
                    display: flex;
                    align-items: center;
                  height: 60px;
                  width: 300px;

                    img{
                        width: 30px;
                    }
                    span{
                        font-size: 28px;
                        color: #999999;
                        margin-left: 10px;
                      line-height:1.5;
                    }
                }
                .time{
                    display: flex;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                    }
                    .t{
                        font-size: 28px;
                        color: #999999;
                        margin-left: 10px;
                        margin-right: auto;
                        line-height: 1;
                    }
                }
                .money-box{
                    display: flex;
                    flex-direction: column;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    .money{
                        font-size: 36px;
                        //color: #0890CE;
                        color: #ff504c;
                        margin-left: auto;
                        font-weight: 600;
                    }
                    .text-mon{
                        color: #606060;
                        font-size: 24px;
                        line-height: 1;
                    }
                    .text-mon.on{
                        font-size: 28px;
                        color: #CCCCCC;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}
</style>